import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../store/appState';
import {
  getFindTeammate,
  makeGetActiveTeammateForEmail,
} from '../../../store/data/teammates/teammatesSelectors';
import {TeammatePopover} from './teammatePopover';

/*
 * Props.
 */

interface TeammatePopoverContainerProps {
  teammateId?: number | undefined;
  teammateEmail?: string;
}

/*
 * Selectors.
 */

function getTeammateId(_state: AppState, props: TeammatePopoverContainerProps) {
  return props.teammateId;
}

function getTeammateEmail(_state: AppState, props: TeammatePopoverContainerProps) {
  return props.teammateEmail;
}

function makeGetTeammate() {
  return createSelector(
    [getFindTeammate, getTeammateId, makeGetActiveTeammateForEmail(getTeammateEmail)],
    (findTeammate, teammateId, teammateForEmail) => {
      if (teammateId) {
        return findTeammate(teammateId);
      }

      if (teammateForEmail) {
        return teammateForEmail;
      }

      return undefined;
    },
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<TeammatePopoverContainerProps>()(() => ({
  teammate: makeGetTeammate(),
}));

export const TeammatePopoverContainer = connect(mapStateToProps)(TeammatePopover);
